var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "기본정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable:
                              _vm.editable &&
                              !_vm.nearAccident.iimNearAccidentId,
                            name: "iimNearAccidentName",
                            label: "아차사고명",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearAccidentName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "iimNearAccidentName",
                                $$v
                              )
                            },
                            expression: "nearAccident.iimNearAccidentName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            name: "iimNearAccidentNo",
                            label: "아차사고번호",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearAccidentNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "iimNearAccidentNo",
                                $$v
                              )
                            },
                            expression: "nearAccident.iimNearAccidentNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-multi-select", {
                          attrs: {
                            required: "",
                            codeGroupCd: "IIM_NEAR_KIND_CD",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            name: "iimNearKindCds",
                            label: "재해유형",
                          },
                          model: {
                            value: _vm.nearAccident.iimNearKindCds,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "iimNearKindCds", $$v)
                            },
                            expression: "nearAccident.iimNearKindCds",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            type: "datetime",
                            disabled: _vm.disabled,
                            minuteStep: 10,
                            label: "사고일시",
                            name: "occurrenceDt",
                          },
                          model: {
                            value: _vm.nearAccident.occurrenceDt,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "occurrenceDt", $$v)
                            },
                            expression: "nearAccident.occurrenceDt",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-location", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            etcFlag: "N",
                            label: "사고장소",
                            name: "locationCd",
                          },
                          model: {
                            value: _vm.nearAccident.locationCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "locationCd", $$v)
                            },
                            expression: "nearAccident.locationCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-process", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "공정",
                            name: "processCd",
                          },
                          model: {
                            value: _vm.nearAccident.processCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "processCd", $$v)
                            },
                            expression: "nearAccident.processCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "occurenceLocation",
                            label: "사고정도",
                          },
                          model: {
                            value: _vm.nearAccident.occurrenceLocation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "occurrenceLocation",
                                $$v
                              )
                            },
                            expression: "nearAccident.occurrenceLocation",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "openning",
                            label: "기인물",
                          },
                          model: {
                            value: _vm.nearAccident.openning,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "openning", $$v)
                            },
                            expression: "nearAccident.openning",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            name: "reportDt",
                            label: "배포일자",
                          },
                          model: {
                            value: _vm.nearAccident.reportDt,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "reportDt", $$v)
                            },
                            expression: "nearAccident.reportDt",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.nearAccident.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "plantCd", $$v)
                            },
                            expression: "nearAccident.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "재해자 정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            isFirstValue: false,
                            data: _vm.nearAccident,
                            deptValue: "occurrenceDeptCd",
                            label: "재해자",
                            type: "dept_user",
                            name: "accidentUserId",
                          },
                          on: { userInfo: _vm.accUserDataChange },
                          model: {
                            value: _vm.nearAccident.accidentUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "accidentUserId", $$v)
                            },
                            expression: "nearAccident.accidentUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            label: "입사일자",
                            name: "accidentEnterDate",
                          },
                          model: {
                            value: _vm.nearAccident.accidentEnterDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "accidentEnterDate",
                                $$v
                              )
                            },
                            expression: "nearAccident.accidentEnterDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            label: "생년월일",
                            name: "accidentBirthDate",
                          },
                          model: {
                            value: _vm.nearAccident.accidentBirthDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nearAccident,
                                "accidentBirthDate",
                                $$v
                              )
                            },
                            expression: "nearAccident.accidentBirthDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            label: "연령/근속년수",
                            name: "companyInfo",
                          },
                          model: {
                            value: _vm.companyInfo,
                            callback: function ($$v) {
                              _vm.companyInfo = $$v
                            },
                            expression: "companyInfo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-select", {
                          attrs: {
                            type: "edit",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            codeGroupCd: "IIM_WOUND_CD",
                            itemText: "codeName",
                            itemValue: "code",
                            name: "woundCd",
                            label: "상해정도",
                          },
                          model: {
                            value: _vm.nearAccident.woundCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "woundCd", $$v)
                            },
                            expression: "nearAccident.woundCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "재해발생 및 방지대책" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            rows: 1,
                            label: "재해발생상황",
                            name: "shortPlan",
                          },
                          model: {
                            value: _vm.nearAccident.shortPlan,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "shortPlan", $$v)
                            },
                            expression: "nearAccident.shortPlan",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            rows: 1,
                            label: "재해발생원인",
                            name: "longPlan",
                          },
                          model: {
                            value: _vm.nearAccident.longPlan,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "longPlan", $$v)
                            },
                            expression: "nearAccident.longPlan",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            rows: 1,
                            label: "재발방지대책",
                            name: "managerOpinion",
                          },
                          model: {
                            value: _vm.nearAccident.managerOpinion,
                            callback: function ($$v) {
                              _vm.$set(_vm.nearAccident, "managerOpinion", $$v)
                            },
                            expression: "nearAccident.managerOpinion",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-table",
                {
                  ref: "tableImpr",
                  attrs: {
                    title: "개선 목록",
                    columns: _vm.gridImpr.columns,
                    data: _vm.nearAccident.imprList,
                    merge: _vm.gridImpr.merge,
                    selection: "multiple",
                    rowKey: "iimNearCausesId",
                    usePaging: false,
                    isExcelDown: false,
                    filtering: false,
                    columnSetting: false,
                    isTitle: true,
                    gridHeightAuto: true,
                    editable: _vm.editable && !_vm.disabled,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "customCol"
                            ? [
                                _c(_vm.imprComponent, {
                                  tag: "component",
                                  attrs: {
                                    col: col,
                                    props: props,
                                    inputEditable:
                                      _vm.editable && !_vm.disabled,
                                    isImmShow: true,
                                    requestContentsCols:
                                      _vm.requestContentsCols,
                                    tableKey: "iimNearCausesId",
                                    ibmTaskTypeCd: "ITT0000045",
                                    ibmTaskUnderTypeCd: "ITTU000070",
                                  },
                                  on: { imprChange: _vm.imprChange },
                                }),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  label: "추가",
                                  showLoading: false,
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.add },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  label: "제외",
                                  showLoading: false,
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeImpr },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "사진추가" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("c-upload", {
                          attrs: {
                            attachInfo: _vm.attachInfo1,
                            label: "원거리",
                            editable: _vm.editable && !_vm.disabled,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("c-upload", {
                          attrs: {
                            attachInfo: _vm.attachInfo2,
                            label: "근거리",
                            editable: _vm.editable && !_vm.disabled,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isOld && !_vm.disabled && _vm.editable,
                      expression: "isOld && !disabled && editable",
                    },
                  ],
                  attrs: {
                    flat: "",
                    url: _vm.completeUrl,
                    isSubmit: _vm.isComplete,
                    param: _vm.nearAccident,
                    mappingType: "PUT",
                    label: "완료",
                    icon: "check",
                  },
                  on: {
                    beforeAction: _vm.completeNearAccident,
                    btnCallback: _vm.completeCallback,
                  },
                }),
                _vm.isOld && !_vm.disabled && _vm.editable
                  ? _c("c-btn", {
                      attrs: {
                        flat: "",
                        label: "삭제",
                        icon: "delete_forever",
                      },
                      on: { btnClicked: _vm.remove },
                    })
                  : _vm._e(),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.disabled && _vm.editable,
                      expression: "!disabled && editable",
                    },
                  ],
                  attrs: {
                    flat: "",
                    url: _vm.saveUrl,
                    isSubmit: _vm.isSave,
                    param: _vm.nearAccident,
                    mappingType: _vm.saveType,
                    label: "저장",
                    icon: "save",
                  },
                  on: {
                    beforeAction: _vm.saveNearAccident,
                    btnCallback: _vm.saveCallback,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }